module.exports = __webpack_public_path__ + "static/media/detail1.be6d65d3.jpg";